import { IconProps } from '../icon-props-interface';
import '../icons.scss';

export const IconUser = ({ color = 'var(--color-accent-1)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.7143 11.875H7.93277C4.10399 11.875 1 14.9531 1 18.75C1 19.4402 1.56447 20 2.2605 20H17.3866C18.0826 20 18.6471 19.4402 18.6471 18.75C18.6471 14.9531 15.5431 11.875 11.7143 11.875ZM2.92975 18.125C3.24094 15.6602 5.3645 13.75 7.93277 13.75H11.7143C14.281 13.75 16.4057 15.6621 16.7169 18.125H2.92975ZM9.82353 10C12.6081 10 14.8655 7.76133 14.8655 5C14.8655 2.23867 12.6081 0 9.82353 0C7.039 0 4.78151 2.23867 4.78151 5C4.78151 7.76172 7.0386 10 9.82353 10ZM9.82353 1.875C11.5611 1.875 12.9748 3.27695 12.9748 5C12.9748 6.72305 11.5611 8.125 9.82353 8.125C8.086 8.125 6.67227 6.72266 6.67227 5C6.67227 3.27695 8.0864 1.875 9.82353 1.875Z" fill={color}/>
        </svg>
    
    
    </div>
);

export default IconUser;
